<!-- eslint-disable vue/no-deprecated-filter -->
<template>
  <v-dialog v-model="dialog" v-if="ativo" width="500" persistent>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ this.nomeEquipe }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <h5 v-if="equipe.length > 0" style="padding-bottom: 8px">Membros:</h5>
          <h5 v-if="equipe.length <= 0">Sem membros cadastrados!</h5>
          <div v-for="n in equipe" :key="n" style="padding-bottom: 20px">
            <v-avatar size="30" style="margin-right: 5px">
              <img :src="n.foto" alt="User Image" class="icon-user" />
            </v-avatar>
            <h5 style="display: inline-block">
              {{ n.nomeEqui }} - {{ filtro(n.formaAtuacao) }}
            </h5>
            <p style="font-size: 12px; margin-left: 42px">
              {{ n.userGit }}
            </p>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue-darken-1"
          variant="text"
          @click="enviarSolicitacaoParaPai"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
    equipe: {
      type: Array,
      default: null,
    },
    nomeEquipe: {
      type: String,
      default: null,
    },
    fotosEquipe: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    dialog: true,
  }),
  methods: {
    enviarSolicitacaoParaPai() {
      this.$emit('solicitacaoFechar', { solicitacao: false });
    },
    filtro(valor) {
      if (valor == 'SCRUM_MASTER') {
        return 'SCRUM MASTER';
      } else if (valor == 'PRODUCT_OWNER') {
        return 'PRODUCT OWNER';
      } else {
        return valor;
      }
    },
  },
};
</script>
<style scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

.avatar-container {
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: flex-end;
  min-width: 24px;
  max-width: 52px;
  flex-grow: 1;
}
.avatar-margin {
  margin-left: -10px;
}

.avatar-margin:nth-of-type(1) {
  z-index: 3;
  margin-left: 0;
}
.avatar-margin:nth-of-type(2) {
  z-index: 2;
}
.avatar-margin:nth-of-type(3) {
  z-index: 1;
}
.avatar-margin:nth-of-type(4) {
  opacity: 0;
}
</style>
